// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file merchant/v1/pricing.proto (package merchant.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { PaymentMethodTypeCode } from "../../common/v1/payment_pb";

/**
 * @generated from enum merchant.v1.RateMode
 */
export const RateMode = proto3.makeEnum(
  "merchant.v1.RateMode",
  [
    {no: 0, name: "RATE_MODE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "RATE_MODE_FLAT", localName: "FLAT"},
    {no: 2, name: "RATE_MODE_PERCENTAGE", localName: "PERCENTAGE"},
  ],
);

/**
 * @generated from enum merchant.v1.ChargeType
 */
export const ChargeType = proto3.makeEnum(
  "merchant.v1.ChargeType",
  [
    {no: 0, name: "CHARGE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CHARGE_TYPE_CONVENIENCE_FEE", localName: "CONVENIENCE_FEE"},
    {no: 2, name: "CHARGE_TYPE_SERVICE_FEE", localName: "SERVICE_FEE"},
    {no: 3, name: "CHARGE_TYPE_SURCHARGE", localName: "SURCHARGE"},
    {no: 4, name: "CHARGE_TYPE_TIP", localName: "TIP"},
    {no: 5, name: "CHARGE_TYPE_SHIPPING_FEE", localName: "SHIPPING_FEE"},
    {no: 6, name: "CHARGE_TYPE_GRATUITY", localName: "GRATUITY"},
  ],
);

/**
 * @generated from enum merchant.v1.DiscountType
 */
export const DiscountType = proto3.makeEnum(
  "merchant.v1.DiscountType",
  [
    {no: 0, name: "DISCOUNT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DISCOUNT_TYPE_COUPON", localName: "COUPON"},
    {no: 2, name: "DISCOUNT_TYPE_GIFT_CARD", localName: "GIFT_CARD"},
    {no: 3, name: "DISCOUNT_TYPE_PROMOTION", localName: "PROMOTION"},
  ],
);

/**
 * Types of taxes applied to a transaction.
 *
 * @generated from enum merchant.v1.TaxType
 */
export const TaxType = proto3.makeEnum(
  "merchant.v1.TaxType",
  [
    {no: 0, name: "TAX_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TAX_TYPE_NATIONAL_TAX", localName: "NATIONAL_TAX"},
    {no: 2, name: "TAX_TYPE_STATE_SALES_TAX", localName: "STATE_SALES_TAX"},
    {no: 3, name: "TAX_TYPE_CITY_SALES_TAX", localName: "CITY_SALES_TAX"},
    {no: 4, name: "TAX_TYPE_LOCAL_SALES_TAX", localName: "LOCAL_SALES_TAX"},
    {no: 5, name: "TAX_TYPE_AMUSEMENT_TAX", localName: "AMUSEMENT_TAX"},
    {no: 6, name: "TAX_TYPE_LEAST_TAX", localName: "LEAST_TAX"},
    {no: 7, name: "TAX_TYPE_SERVICE_TAX", localName: "SERVICE_TAX"},
    {no: 8, name: "TAX_TYPE_COMMUNICATION_TAX", localName: "COMMUNICATION_TAX"},
    {no: 9, name: "TAX_TYPE_PROVISIONAL_SALES_TAX", localName: "PROVISIONAL_SALES_TAX"},
    {no: 10, name: "TAX_TYPE_VAT", localName: "VAT"},
    {no: 11, name: "TAX_TYPE_GST", localName: "GST"},
    {no: 12, name: "TAX_TYPE_HST", localName: "HST"},
    {no: 13, name: "TAX_TYPE_QST", localName: "QST"},
    {no: 14, name: "TAX_TYPE_ENERGY_TAX", localName: "ENERGY_TAX"},
    {no: 15, name: "TAX_TYPE_OTHER_TAX", localName: "OTHER_TAX"},
    {no: 16, name: "TAX_TYPE_IMPORT_TAX", localName: "IMPORT_TAX"},
    {no: 17, name: "TAX_TYPE_ALTERNATE_TAX", localName: "ALTERNATE_TAX"},
    {no: 18, name: "TAX_TYPE_SHIPPING_VAT_TAX", localName: "SHIPPING_VAT_TAX"},
    {no: 19, name: "TAX_TYPE_PST", localName: "PST"},
  ],
);

/**
 * @generated from message merchant.v1.TaxRate
 */
export const TaxRate = proto3.makeMessageType(
  "merchant.v1.TaxRate",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tax_type_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "tax_type_code", kind: "enum", T: proto3.getEnumType(TaxType) },
    { no: 4, name: "tax_mode", kind: "enum", T: proto3.getEnumType(RateMode) },
    { no: 5, name: "tax_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "tax_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "tax_metadata", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 8, name: "value_added_tax_invoice_reference_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "party_tax_government_issued_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Additional charges applied on a Transaction either from the merchant or the consumer end.
 *
 * @generated from message merchant.v1.TransactionCharge
 */
export const TransactionCharge = proto3.makeMessageType(
  "merchant.v1.TransactionCharge",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "fee_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "charge_type", kind: "enum", T: proto3.getEnumType(ChargeType) },
    { no: 4, name: "charge_mode", kind: "enum", T: proto3.getEnumType(RateMode) },
    { no: 5, name: "purchase_transaction_fee_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "transaction_fee_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "tax", kind: "message", T: TaxRate },
    { no: 8, name: "charge_metadata", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 9, name: "sub_merchant_info", kind: "message", T: SubMerchantInfo },
    { no: 10, name: "payment_method_type_code", kind: "enum", T: proto3.getEnumType(PaymentMethodTypeCode), opt: true },
  ],
);

/**
 * @generated from message merchant.v1.SubMerchantInfo
 */
export const SubMerchantInfo = proto3.makeMessageType(
  "merchant.v1.SubMerchantInfo",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "merchant_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Discounts - actual application of a coupon or promotion code to the subtotal.
 *
 * @generated from message merchant.v1.Discount
 */
export const Discount = proto3.makeMessageType(
  "merchant.v1.Discount",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "discount_type_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "discount_type", kind: "enum", T: proto3.getEnumType(DiscountType) },
    { no: 4, name: "discount_mode", kind: "enum", T: proto3.getEnumType(RateMode) },
    { no: 5, name: "transaction_discount_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "purchase_transaction_discount_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "promotion_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "discount_tax", kind: "message", T: TaxRate },
    { no: 9, name: "discount_metadata", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ],
);

